import { Story } from '../../DocTypes';

export const listItemClickedStory: Story = {
  title: 'List Item Clicked',
  description: 'List item Clicked',
  coreComponent: {
    html: `<tag-list primary-field='name'></tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Harry Maguire' },
      { name: 'Luke Shaw' },
      { name: 'Mason Mount' },
      { name: 'Jude Bellingham' },
    ]);
    tagList.addEventListener('listItemClicked', function(e) {
      console.log(e.detail.item.name + ' has been clicked!');
    });
  });
    `,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    return(
      <div>
        <TagList
          primaryField='name'
          onListItemClicked={e => console.log("item clicked:", e.detail.item)}
          data={[
            { name: 'Harry Maguire' },
            { name: 'Luke Shaw' },
            { name: 'Mason Mount' },
            { name: 'Dele Alli' },
          ]}
        />
      </div>
    )}`,
  },
};
